import React, { useState, useEffect } from "react";
import { Button, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Dialog, DialogTitle, DialogContent, IconButton, Box, Grid, Divider, Accordion, AccordionSummary, AccordionDetails, Card, CardContent } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Typography } from "antd";
import Loader from '../../../Components/Loader';
import { DateTime } from "luxon";
import { Colors } from "../../../Styles/Colors";
import DownloadIcon from '@mui/icons-material/Download';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const AbhaConsentRequestList = () => {
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [data, setData] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData()
    }, [])

  const formatISTDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    // Get parts
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  }         

  const handleRefresh = () => {
    fetchData();
  };

  const fetchData = () => {
    try{
      setLoading(true);
      var FromDate = fromDate ? DateTime.fromJSDate(fromDate).toFormat('yyyy-MM-dd') : "";
      var ToDate = toDate ? DateTime.fromJSDate(toDate).toFormat('yyyy-MM-dd') : "";
      var API_URL = Serviceurls.ABHA_CONSENT_INIT + `?from_date=${FromDate}&to_date=${ToDate}`;
      RestAPIService.getAll(API_URL).
      then((response) => {
        if (response?.data?.status === "success") {
          setData(response?.data?.data)
          setLoading(false);
        }
        else {
          setLoading(false);
          // this.errorMessage(response.data.message)
        }
      }).catch((error) => {
        setLoading(false);
        // this.errorMessage(error.message)
      })

    }catch(e){

    }
  };

  const handleReset = () => {
    setFromDate(new Date());
    setToDate(new Date());
  };

  const handleViewData = (id) => {
    try{
      setSelectedData([]);
      setLoading(true);
      var API_URL = Serviceurls.ABHA_CONSENT_BUNDLE_VIEW + `?consent_id=${id}`;
      RestAPIService.getAll(API_URL).
      then((response) => {
        if (response?.data?.status === "success") {
          setSelectedData(response?.data?.data?.bundles || []);
          setLoading(false);
          setOpenDialog(true);
        }
        else {
          setLoading(false);
          // this.errorMessage(response.data.message)
        }
      }).catch((error) => {
        setLoading(false);
        // this.errorMessage(error.message)
      })

    }catch(e){

    }
  };

  return (
    <div style={{padding: "20px"}}>
      {/* First Row */}
      <div style={{ display: "flex", gap: "2%", marginBottom: 16 }}>
        <Button size="small" variant="contained" startIcon={<RefreshIcon />} onClick={handleRefresh} sx={{textTransform:'capitalize'}}>
          Refresh
        </Button>
        <TextField
          size="small"
          label="From Date"
          type="date"
          InputLabelProps={{ shrink: true }}
          value={fromDate ? DateTime.fromJSDate(new Date(fromDate)).toFormat('yyyy-MM-dd') : ""}
          onChange={(e) => setFromDate(e.target.value ? new Date(e.target.value) : null)}
        />
        <TextField
          size="small"
          label="To Date"
          type="date"
          InputLabelProps={{ shrink: true }}
          value={toDate ? DateTime.fromJSDate(new Date(toDate)).toFormat('yyyy-MM-dd') : ""}
          onChange={(e) => setToDate(e.target.value ? new Date(e.target.value) : null)}
        />
        <Button size="small" variant="contained" startIcon={<SearchIcon />} onClick={fetchData} sx={{textTransform:'capitalize'}}>Submit</Button>
        <Button size="small" variant="contained" onClick={handleReset} sx={{textTransform:'capitalize'}}>Reset</Button>
        {/* <Button variant="contained" color='info' onClick={() => {}}>PHR HIT</Button> */}
      </div>

      {/* Table Section */}
      <TableContainer component={Paper} style={{ maxHeight: "68vh", overflowY: "auto" }}>
        <Table>
          <TableHead>
            <TableRow sx={{  display: "flex", flexDirection: "row"}}>
              <TableCell sx={{flex: 0.04}}>S.No</TableCell>
              <TableCell sx={{flex: 0.06}}>Data</TableCell>
              <TableCell sx={{flex: 0.15}}>Requested HI Types</TableCell>
              <TableCell sx={{flex: 0.15}}>Granted HI Types</TableCell>
              <TableCell sx={{flex: 0.10}}>Consent Status</TableCell>
              {/* <TableCell sx={{flex: 0.08}}>Expiry Status</TableCell> */}
              <TableCell sx={{flex: 0.14}}>ABHA Address</TableCell>
              <TableCell sx={{flex: 0.12}}>Requested</TableCell>
              <TableCell sx={{flex: 0.12}}>Granted</TableCell>
              <TableCell sx={{flex: 0.12}}>Action Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((row, index) => (
              <TableRow key={index} sx={{  display: "flex", flexDirection: "row"}}>
                <TableCell sx={{fontSize: '0.7vw', flex: 0.04}}>{index + 1}</TableCell>
                <TableCell sx={{flex: 0.06}}>
                  <Button disabled={row?.status != "GRANTED" || row?.expiry_status == "EXPIRED"} sx={{fontSize: '0.7vw', textTransform:'capitalize'}} variant="contained" onClick={() => handleViewData(row?.id)}>View</Button>
                </TableCell>
                <TableCell sx={{fontSize: '0.7vw', flex: 0.15}}>{(row?.request_hi_types)?.length > 0 ? row?.request_hi_types.join(", ") : ""}</TableCell>
                <TableCell sx={{fontSize: '0.7vw', flex: 0.15}}>{(row?.grant_hi_types)?.length > 0 ? row?.grant_hi_types.join(", ") : ""}</TableCell>
                <TableCell sx={{fontSize: '0.7vw', flex: 0.10}}>{(row?.expiry_status === "EXPIRED") ? row?.expiry_status : row?.status}</TableCell>
                {/* <TableCell sx={{fontSize: '0.7vw', flex: 0.08}}>{(row?.expiry_status === "EXPIRED") ? row?.expiry_status : row?.expiry_status}</TableCell> */}
                <TableCell sx={{fontSize: '0.7vw', flex: 0.14}}>{row?.abha_health_address}</TableCell>
                <TableCell sx={{fontSize: '0.7vw', flex: 0.12}}>
                    <span style={{ fontSize: '0.7vw', fontWeight: 'bold' }}>
                      From Date
                    </span>
                    <br/>
                    <span style={{ fontSize: '0.7vw' }}>
                      {formatISTDate(row?.permission_date_range_from)}
                    </span>
                    <br/>
                    <span style={{ fontSize: '0.7vw', fontWeight: 'bold' }}>
                      To Date
                    </span>
                    <br/>
                    <span style={{ fontSize: '0.7vw' }}>
                      {formatISTDate(row?.permission_date_range_to)}
                    </span>
                </TableCell>
                <TableCell sx={{fontSize: '0.7vw', flex: 0.12}}>
                  <span style={{ fontSize: '0.7vw', fontWeight: 'bold' }}>
                      From Date
                    </span>
                    <br/>
                    <span style={{ fontSize: '0.7vw' }}>
                      {formatISTDate(row?.patient_permission_date_range_from)}
                    </span>
                    <br/>
                    <span style={{ fontSize: '0.7vw', fontWeight: 'bold' }}>
                      To Date
                    </span>
                    <br/>
                    <span style={{ fontSize: '0.7vw' }}>
                      {formatISTDate(row?.patient_permission_date_range_to)}
                    </span>
                </TableCell>
                <TableCell sx={{fontSize: '0.7vw', flex: 0.12}}>
                    <span style={{ fontSize: '0.7vw', fontWeight: 'bold' }}>
                      Created At
                    </span>
                    <br/>
                    <span style={{ fontSize: '0.7vw' }}>
                      {row?.created_date ? formatISTDate(row?.created_date) : ""}
                    </span>
                    <br/>
                    <span style={{ fontSize: '0.7vw', fontWeight: 'bold' }}>
                      Granted At
                    </span>
                    <br/>
                    <span style={{ fontSize: '0.7vw' }}>
                      {row?.granted_date ? formatISTDate(row?.granted_date) : ""}
                    </span>
                    <br/>
                    <span style={{ fontSize: '0.7vw', fontWeight: 'bold' }}>
                      Denied At
                    </span>
                    <br/>
                    <span style={{ fontSize: '0.7vw' }}>
                      {row?.denied_date ? formatISTDate(row?.denied_date) : ""}
                    </span>
                    <br/>
                    <span style={{ fontSize: '0.7vw', fontWeight: 'bold' }}>
                      Revoked At
                    </span>
                    <br/>
                    <span style={{ fontSize: '0.7vw' }}>
                      {row?.revoked_date ? formatISTDate(row?.revoked_date) : ""}
                    </span>
                    <br/>
                    <span style={{ fontSize: '0.7vw', fontWeight: 'bold' }}>
                      Expired At
                    </span>
                    <br/>
                    <span style={{ fontSize: '0.7vw' }}>
                      {row?.permission_data_erased_at ? formatISTDate(row?.permission_data_erased_at) : ""}
                    </span>
                    <br/>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Dialog for JSON Data */}
    <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
  <DialogTitle>
    Patient Health Records
    <IconButton onClick={() => setOpenDialog(false)} style={{ position: "absolute", right: 10, top: 10 }}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>
  <DialogContent dividers style={{ maxHeight: "500px", overflowY: "auto" }}>
    {selectedData && selectedData.length > 0 ? selectedData.map((item, idx) => (
      <Box key={idx} mb={3} pb={2} borderBottom="1px solid #ccc">
        <Accordion defaultExpanded={idx == "0" ? true : false}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        {/* <Box display="flex" justifyContent="center" alignItems="center" mb={2} sx={{ backgroundColor: Colors.disableComponentColor, color: "white", padding: 1 }}> */}
        <Typography>
          {/* <span style={{ fontWeight:"bold" }}>HI Type: </span> */}
          {item?.hi_type == "OpConsult Record"  ? "OP Consultation" : item?.hi_type}
        </Typography>
        {/* </Box> */}
        </AccordionSummary>
        <AccordionDetails sx={{mb: 1}}>
        <Typography style={{fontStyle: "italic", marginTop: 2, borderTop: "1px solid #ccc"}} color={Colors.disableComponentColor}><strong>Patient Details</strong></Typography>
        <Grid container spacing={2} >
          <Grid item xs={12} sm={6}>
            <Typography><strong>Name:</strong> {item?.patient?.name || "-"}</Typography>
            <Typography><strong>Gender:</strong> {item?.patient?.gender || "-"}</Typography>
            <Typography><strong>Date of Birth:</strong> {item?.patient?.dob || "-"}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography><strong>Mobile:</strong> {item?.patient?.mobile || "-"}</Typography>
            <Typography><strong>ABHA Address:</strong> {item?.patient?.medical_record_no || "-"}</Typography>
            <Typography><strong>ABHA Number:</strong> {item?.patient?.abha_id || "-"}</Typography>
          </Grid>
        </Grid>
        <Divider sx={{ mb: 1 }} />
        <Typography variant="subtitle1" color="secondary" mb={1}>
          <strong>Facility:</strong> {item?.organization?.name || "-"}
        </Typography>
        <Typography variant="body2" mb={2}>
          <strong>Practitioner:</strong> {item?.doctor?.name || "-"}
        </Typography>
        <Divider sx={{ mb: 1 }} />
        <div style={{display: "flex", flexDirection: "row", flexWrap: "wrap"}}>
        {item?.information && Object.keys(item?.information).map((infoKey, infoIdx) => (
          <Card sx={{width: "100%", margin:"1%",}}>
            <CardContent>
            <Box key={infoIdx} mb={2}>
            <Typography variant="subtitle1" color="primary" mb={1}>
              {infoKey.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase())}
            </Typography>
            {Array.isArray(item?.information[infoKey]) && item?.information[infoKey].length > 0 ? (
              item?.information[infoKey]?.map((infoObj, infoObjIdx) => (
                <Box key={infoObjIdx} mb={1} pl={2}>
                  {infoKey === "Document Reference" && infoObj?.files && Array.isArray(infoObj?.files) ? (
                    infoObj?.files.map((file, fileIdx) => (
                      <Box 
                      key={fileIdx} 
                      display="flex"
                      mb={1}
                      alignItems="center"
                      sx={{ cursor: "pointer" }}
                      onClick={() => {
                        const link = document.createElement('a');
                        link.href = `data:application/pdf;base64,${file?.data}`;
                        link.download = (file?.title || "document") + ".pdf";
                        link.click();
                      }}>
                        <Typography sx={{ mr: 2 }}>
                          <strong>{file?.title || "Document Reference"}</strong>
                        </Typography>
                        <IconButton size='small' color="primary" sx={{padding: "0.1vw"}}
                        onClick={(e) => {
                          e.stopPropagation();
                          const link = document?.createElement('a');
                          link.href = `data:application/pdf;base64,${file?.data}`;
                          link.download = (file?.title || "document") + ".pdf";
                          link.click();
                        }}
                        ><DownloadIcon fontSize='0.7vw'/></IconButton>
                      </Box>
                    ))
                  ) : (
                    Object.entries(infoObj)
                    .filter(([k]) => !["status", "intent", "id", "authored_on"].includes(k)) 
                    .map(([k, v], i) => {
                      let displayValue;

                      if (Array.isArray(v)) {
                        displayValue = v.map((item, idx) => {
                          if (typeof item === "object" && item !== null) {
                            return (
                              <div key={idx} style={{ marginLeft: "16px" }}>
                                {Object.entries(item).map(([ik, iv], subIdx) => (
                                  <Typography key={subIdx} sx={{ ml: 2 }}>
                                    <strong>
                                      {ik.replace(/_/g, " ").replace(/([A-Z])/g, " $1").replace(/^./, str => str?.toUpperCase())}:
                                    </strong> {iv || "-"}
                                  </Typography>
                                ))}
                              </div>
                            );
                          }
                          return <div key={idx}>{item}</div>;
                        });
                      } else if (typeof v === "object" && v !== null) {
                        displayValue = Object.entries(v).map(([ik, iv], subIdx) => (
                          <Typography key={subIdx} sx={{ ml: 2 }}>
                            <strong>
                              {ik.replace(/_/g, " ").replace(/([A-Z])/g, " $1").replace(/^./, str => str?.toUpperCase())}:
                            </strong> {iv || "-"}
                          </Typography>
                        ));
                      } else {
                        displayValue = v || "-";
                      }

                      return (
                        <Typography key={i} sx={{ ml: 2 }}>
                          <strong>
                            {k.replace(/_/g, " ").replace(/([A-Z])/g, " $1").replace(/^./, str => str?.toUpperCase())}:
                          </strong> {displayValue}
                        </Typography>
                      )
                    })
                  )}
                </Box>
              ))
            ) : (
              <Typography sx={{ ml: 2 }}>No data</Typography>
            )}
            </Box>
          </CardContent>
          </Card>
        ))}
        </div>
        </AccordionDetails>
      </Accordion>
      </Box>
    )) : (
      <Typography>No data</Typography>
    )}
  </DialogContent>
    </Dialog>
    <Loader loaderOpen={loading} />
    </div>
  );
};

export default AbhaConsentRequestList;
